import React from 'react';
import {
    List,
    Datagrid,
    TextField,
    FunctionField,
    ImageField,
    TextInput,
    Filter,
    TopToolbar,
    FilterButton,
    Edit,
    SimpleForm,
    ImageInput,
    ImageField as ImageFieldEdit,
    Pagination,
    useNotify,
    useRefresh,
    useRedirect,
} from 'react-admin';
import Icon from '@mui/icons-material/SportsTennis';

export const VolleyClubIcon = Icon;

const filterArray = [
    <TextInput source="nom_like" label="Nom" />,
    <TextInput source="region" label="Région" />,
];

const FilterList = (props) => (
    <Filter {...props}>{filterArray}</Filter>
);

const ListActions = () => (
    <TopToolbar>
        <FilterButton filters={filterArray} />
    </TopToolbar>
);

export const VolleyClubList = (props) => (
    <List
        {...props}
        filters={<FilterList />}
        actions={<ListActions />}
        perPage={50}
        pagination={<Pagination rowsPerPageOptions={[20, 50, 100]} />}
    >
        <Datagrid rowClick="edit">
            <TextField source="affiliation_no" label="N° affiliation" />
            <TextField source="nom" label="Nom" />
            <TextField source="region" label="Région" />
            <FunctionField
                label="Logo actuel"
                render={(record) => {
                    const src = record.imageUrl || record.logo;
                    return src ? (
                        <img src={src} alt={record.nom} style={{ maxHeight: 40, maxWidth: 60, objectFit: 'contain' }} />
                    ) : <span style={{ color: '#aaa' }}>—</span>;
                }}
            />
            <FunctionField
                label="Source logo"
                render={(record) => record.imageUuid ? '📦 S3' : (record.logo ? '🔗 URL' : '—')}
            />
        </Datagrid>
    </List>
);

export const VolleyClubEdit = (props) => {
    const notify = useNotify();
    const refresh = useRefresh();
    const redirect = useRedirect();

    const handleSubmit = async (values) => {
        const token = localStorage.getItem('token');
        const API_URL = process.env.REACT_APP_API_HOSTNAME;
        const affiliationNo = values.affiliation_no;

        try {
            let imageUuid = values.imageUuid || null;

            // Si un nouveau fichier est sélectionné, on l'upload d'abord
            if (values.newImage?.rawFile) {
                const formData = new FormData();
                formData.append('file', values.newImage.rawFile);

                const uploadRes = await fetch(`${API_URL}/images`, {
                    method: 'POST',
                    headers: { Authorization: `Bearer ${token}` },
                    body: formData,
                });
                const uploadJson = await uploadRes.json();
                if (!uploadRes.ok || uploadJson.result !== 'success') {
                    notify(uploadJson.message || "Erreur upload image", { type: 'error' });
                    return;
                }
                imageUuid = uploadJson.uuid;
            }

            // Assigner l'image au club
            const res = await fetch(`${API_URL}/superuser/volleyclub/${affiliationNo}/image`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify({ imageUuid }),
            });
            const json = await res.json();
            if (!res.ok || json.result !== 'success') {
                notify(json.message || 'Erreur', { type: 'error' });
                return;
            }

            notify('Logo mis à jour', { type: 'success' });
            redirect('/VolleyClub');
            refresh();
        } catch (e) {
            notify('Erreur réseau', { type: 'error' });
        }
    };

    return (
        <Edit {...props}>
            <SimpleForm onSubmit={handleSubmit}>
                <TextField source="affiliation_no" label="N° affiliation" />
                <TextField source="nom" label="Nom" />
                <TextField source="region" label="Région" />
                <FunctionField
                    label="Logo actuel"
                    render={(record) => {
                        const src = record.imageUrl || record.logo;
                        return src ? (
                            <img src={src} alt="logo actuel" style={{ maxHeight: 80, maxWidth: 120, objectFit: 'contain', marginBottom: 8 }} />
                        ) : <span style={{ color: '#aaa' }}>Aucun logo</span>;
                    }}
                />
                <ImageInput source="newImage" label="Nouveau logo (upload)" accept="image/*">
                    <ImageFieldEdit source="src" title="title" />
                </ImageInput>
            </SimpleForm>
        </Edit>
    );
};
